/**
 * Vitrin fiyat katmanı — yalnızca web indirimi.
 * B2B fiyatı temada hesaplanmaz; Clay Wholesale Price embed yazar.
 */
(function () {
  "use strict";

  function isB2BCustomer() {
    return window.hrcIsB2B === true;
  }

  function toCents(value) {
    const n = Number(value);
    return Number.isFinite(n) && n > 0 ? Math.round(n) : 0;
  }

  function config() {
    const d = window.hrcWebDiscount || {};
    return {
      enabled: d.enabled === true && !isB2BCustomer(),
      percent: Math.max(0, Math.min(90, Number(d.percent) || 0)),
      label: String(d.label || "").trim(),
    };
  }

  function b2bConfig() {
    const d = window.hrcB2BDiscount || {};
    return {
      enabled: isB2BCustomer(),
      percent: Math.max(0, Number(d.percent) || 0),
      label: String(d.label || "").trim(),
    };
  }

  function clayPriceMarkup({
    productId = "",
    variantId = "",
    catalogText = "",
    currentClass = "",
    compareClass = "",
  }) {
    const pid = String(productId || "");
    const vid = variantId ? String(variantId) : "";
    const ids = `data-product-id="${pid}"${vid ? ` data-variant-id="${vid}"` : ""}`;
    return `<div class="hrc-clay-feed" aria-hidden="true"><div class="price__regular"><span class="price-item price-item--regular money" ${ids}>${catalogText}</span></div><div class="price__sale"><span class="price-item price-item--regular">${catalogText}</span><span class="price-item price-item--sale money" ${ids}>${catalogText}</span></div></div><div class="hrc-clay-ui"><s class="${compareClass}" data-hrc-clay-compare hidden></s><span class="${currentClass}" data-hrc-clay-face>${catalogText}</span></div>`;
  }

  function notifyPricingApps(root, detail) {
    const payload = detail && typeof detail === "object" ? detail : {};
    try {
      document.dispatchEvent(
        new CustomEvent("variant:change", {
          bubbles: true,
          detail: { source: "hrc", root: root || document, ...payload },
        }),
      );
      document.dispatchEvent(
        new CustomEvent("hrc:prices-ready", {
          bubbles: true,
          detail: { root: root || document, ...payload },
        }),
      );
    } catch (_) {
      /* ignore */
    }
  }

  function applyPercentToCents(cents, percent) {
    const amount = toCents(cents);
    const pct = Math.max(0, Math.min(90, Number(percent) || 0));
    if (pct <= 0 || amount <= 0) return amount;
    return Math.round((amount * (100 - pct)) / 100);
  }

  function applyToCents(cents) {
    const c = config();
    const amount = toCents(cents);
    if (!c.enabled || c.percent <= 0 || amount <= 0) return amount;
    return applyPercentToCents(amount, c.percent);
  }

  /**
   * 212415 kuruş → "2.124,15TL"
   * toLocaleString kullanılmaz: ICU eksik ortamlarda 2124.15TL üretir.
   */
  function formatCents(cents, { forceDecimals = true } = {}) {
    const abs = toCents(cents);
    const major = Math.floor(abs / 100);
    const minor = abs % 100;
    const grouped = String(major).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    if (!forceDecimals && minor === 0) return `${grouped}TL`;
    return `${grouped},${String(minor).padStart(2, "0")}TL`;
  }

  function formatMoney(centsOrMajor, { fromMajor = false, forceDecimals = true } = {}) {
    const cents = fromMajor
      ? Math.round(Number(centsOrMajor) * 100)
      : centsOrMajor;
    return formatCents(cents, { forceDecimals });
  }

  /**
   * @returns {{ price: number, compare: number, webDiscount: boolean, b2bDiscount: boolean, percent: number, label: string }}
   */
  function resolveDisplayPricing(priceCents, compareAtCents) {
    const price = toCents(priceCents);
    const compareAt = toCents(compareAtCents);
    const baseCompare = compareAt > price ? compareAt : 0;
    const empty = {
      price,
      compare: baseCompare,
      webDiscount: false,
      b2bDiscount: false,
      percent: 0,
      label: "",
    };

    if (price <= 0) return empty;

    if (b2bConfig().enabled) {
      return empty;
    }

    const c = config();
    if (!c.enabled || c.percent <= 0) return empty;

    const discounted = applyToCents(price);
    const compare = baseCompare > discounted ? baseCompare : price > discounted ? price : 0;
    return {
      price: discounted,
      compare,
      webDiscount: discounted < price,
      b2bDiscount: false,
      percent: c.percent,
      label:
        c.label ||
        (window.hrcI18n?.webDiscountLabel || "Web Exclusive __PERCENT__% Off")
          .replace("__PERCENT__", String(c.percent))
          .replace("{{ percent }}", String(c.percent)),
    };
  }

  window.HrcWebDiscount = {
    config,
    applyToCents,
    resolveDisplayPricing,
    formatCents,
    formatMoney,
  };
  window.HrcB2B = {
    isCustomer: isB2BCustomer,
    skipThemePricePaint: isB2BCustomer,
    notifyPricingApps,
    config: b2bConfig,
    priceMarkup: clayPriceMarkup,
  };
  window.HrcFormatMoney = formatMoney;
})();
